import styles from "./cloud.module.css";

const Cloud = () => {
  return (
    <div className={styles.center}>
      <div className={styles.cloud}></div>
    </div>
  );
};

export default Cloud;
